import React from "react";
// The nav glyphs are the design team's own SVGs, pulled in as components so a
// className can size them. They already draw in the sidebar ink (#00424B), so
// nothing that uses them has to recolour them.
import { ReactComponent as DashboardIcon } from "../../assets/svg/sidebar/dashboard.svg";
import { ReactComponent as ClientsIcon } from "../../assets/svg/sidebar/clients-active.svg";
import { ReactComponent as EnquiriesIcon } from "../../assets/svg/sidebar/Enquiries.svg";
import { ReactComponent as CreatePlanIcon } from "../../assets/svg/sidebar/plan icon.svg";
import { ReactComponent as DishesIcon } from "../../assets/svg/sidebar/dishes.svg";
import { ReactComponent as RevenueIcon } from "../../assets/svg/sidebar/analytics-up.svg";
import { ReactComponent as MyBrandIcon } from "../../assets/svg/sidebar/my-brand.svg";
import { ReactComponent as CreatePageIcon } from "../../assets/svg/sidebar/create-page.svg";
import { ReactComponent as SettingsIcon } from "../../assets/svg/sidebar/settings.svg";
import { ReactComponent as LaunchIcon } from "../../assets/svg/sidebar/launch.svg";
import { ROUTES } from "../../routes/paths";

export type NavIcon = React.FC<React.SVGProps<SVGSVGElement>>;

/**
 * The glyph each sidebar destination is known by, keyed by its route. Kept
 * here rather than in the rail because screens that have not been built yet
 * show the same icon their nav item does — one mapping, so the two cannot
 * drift apart.
 */
export const NAV_ICONS: Record<string, NavIcon> = {
  [ROUTES.dashboard]: DashboardIcon,
  [ROUTES.myClients]: ClientsIcon,
  [ROUTES.enquiries]: EnquiriesIcon,
  [ROUTES.createPlan]: CreatePlanIcon,
  [ROUTES.dishes]: DishesIcon,
  [ROUTES.revenue]: RevenueIcon,
  [ROUTES.myBrand]: MyBrandIcon,
  [ROUTES.createPage]: CreatePageIcon,
  [ROUTES.launchApp]: LaunchIcon,
  // No entry for `billing`: it is a tab of Settings rather than a rail item,
  // so there is no nav glyph for it to be known by.
  [ROUTES.settings]: SettingsIcon,
};
